import PropertyDisplay from "./PropertyDisplay";

interface AvailabilityProps {
  area: string;
  title: string;
  type: "tenant" | "availability";
  parentUrl?: string;
  portfolio: any;
  properties: any[];
}

const Availability = ({ properties, area, title, type, parentUrl, portfolio }: AvailabilityProps) => {
  let brandingColor = portfolio?.styles?.main ? portfolio?.styles?.main : null;

  return (
    <PropertyDisplay
      properties={properties}
      title={title}
      area={area}
      brandingColor={brandingColor}
      isAvail={type == "availability"}
      parentUrl={parentUrl}
    />
  );
};

export default Availability;
